import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import AppliedRoute from "../routes/AppliedRoute"

import AdminTopNavbar from "../components/Navbars/AdminTopNavbar"
import AdminSideBar from "../components/Navbars/AdminSideBar"
import AdminContentBox from "../components/Content/AdminContentBox"
import UserRoutes from "../routes/UserRoutes"
import NotFound from "../views/NotFound"
import ErrorBoundary from "../components/ErrorBoundaries/TopErrorBoundary";

import useToggle from "../hooks/useToggle";

function AdminLayout(props) {
  const [sideBar, toggleSideBar] = useToggle(false);
  const currentRoute = UserRoutes.filter(el => el.path === props.location.pathname)[0];
  const routeName = currentRoute ? currentRoute.name : '';
  return (
    <div>
      <AdminTopNavbar	menuClick={toggleSideBar}	menuOpen={sideBar} title={routeName}/>
      <AdminSideBar	open={sideBar} toggle={toggleSideBar}	routes={UserRoutes}/>
      <AdminContentBox sideBarOpen={sideBar}>
        <ErrorBoundary>
          <Switch>
            {UserRoutes.map(el => <AppliedRoute key={el.name} exact path={el.path} component={el.component}/>)}
            <Redirect from="/user" to="/user/vehicles" />
            <Route component={NotFound} />
          </Switch>
        </ErrorBoundary>
      </AdminContentBox>
    </div>
  )
}

export default AdminLayout;
